
  var _styles = {
  "no-prize-modal-content-wrap": {
    "width": "9.13333rem",
    "height": "7.36rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "no-prize-modal-content": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "width": "100%",
    "height": "100%",
    "position": "relative",
    "marginLeft": 0
  },
  "no-prize-modal-action-btn": {
    "width": "6rem",
    "height": "1.28rem",
    "marginTop": "4.53333rem"
  }
};



  module.exports = _styles;
  